import {get, post} from "@/config/api";

const state = {
  unreadData: {},
  updateTime: 0,
};

const getters = {
};

const mutations = {
};

const actions = {
  GetNotificationList({}, params) {
    return new Promise((resolve, reject) => {
      get("notification/mine/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetNotificationUnreadCount({}, params) {
    return new Promise((resolve, reject) => {
      get("notification/unread_count/", params).then((data) => {
        state.unreadData = data
        state.updateTime = Math.floor(Date.now() / 1000)
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetCachedNotificationUnreadCount({}, params) {
    return new Promise((resolve, reject) => {
      if (Math.floor(Date.now() / 1000) - state.updateTime < 15 && state.unreadData && state.unreadData.code === 0) {
        resolve(state.unreadData)
      } else {
        get("notification/unread_count/", params).then((data) => {
          state.unreadData = data
          state.updateTime = Math.floor(Date.now() / 1000)
          resolve(data)
        }, (err)=> {
          reject(err)
        })
      }
    })
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
